import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import PlayerRow from './PlayerRow';

function PlayerStatTable({ players, handleEnter, handleExit, handleStatChange }) {
    return (
        <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>Pelaaja</TableCell>
              <TableCell>Aika</TableCell>
              <TableCell>Syötöt</TableCell>
              <TableCell>Vedot</TableCell>
              <TableCell>Maalit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...players]
              .map((player) => {
                // Calculate onField for sorting
                let onField = false;
                player.sessions.forEach((s) => {
                  if (!s.exit) {
                    onField = true;
                  }
                });
                return { ...player, onField };
              })
              .sort((a, b) => b.onField - a.onField)
              .map((player) => (
                <PlayerRow
                  key={player.id}
                  player={player}
                  onEnter={handleEnter}
                  onExit={handleExit}
                  onStatChange={handleStatChange}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
}

export default PlayerStatTable;